/* Sticky header height fix — theme.js's own stickyHeaderHeight() (in the
   SiteHeader/sticky-nav module) captures siteHeader.offsetHeight exactly
   once at page load, and only ever recalculates it on a real window
   resize event. This site's custom fonts load from Typekit and can swap
   in shortly AFTER that first measurement (reflowing the announcement
   bar/nav to their final text metrics and changing the header's real
   height), but nothing tells the sticky wrapper to re-measure when that
   happens — so it's left holding a stale height until an actual resize
   fires, which is why the gap only "fixes itself" on a lucky refresh
   (depends on whether the font happens to be warm in cache) or a manual
   window resize, not reliably on a plain page load. Scrolling doesn't
   actually fix the stale value either — past 250px the header just
   switches to position:fixed, which visually hides the mismatch instead
   of resolving it.

   Rather than hand-editing theme.js (a large base file, risky to patch,
   and not ours to begin with), this dispatches a real resize event once
   document.fonts.ready confirms every font has finished loading/swapping
   — theme.js's existing, unmodified resize listener already reacts to
   that and re-runs stickyHeaderHeight() with the correct final height. */
(function () {
  function triggerResize() {
    window.dispatchEvent(new Event('resize'));
  }

  if (window.document && document.fonts && document.fonts.ready) {
    document.fonts.ready.then(triggerResize);
  }

  // Fallback safety net for any other late-settling content (e.g. a
  // slow-loading logo image) that can also shift the header's height
  // shortly after the first measurement.
  window.addEventListener('load', function () {
    setTimeout(triggerResize, 100);
  });
})();

/* Contact us Form */
if (document.getElementById('ContactFormCountry')) {
  document.getElementById('ContactFormCountry').addEventListener('change', function() {
    const statesDropdown = document.getElementById('statesDropdown');
    const statesField = document.getElementById('statesField');
    
    if (this.value !== 'United States of America') {
      statesDropdown.style.display = 'none';
      statesField.style.display = 'block';
    } else {
      statesDropdown.style.display = 'block';
      statesField.style.display = 'none';
    }
  });
}

/* Collection Color Swatch Expand */
document.body.addEventListener('click', function(event) {
  if (event.target.classList.contains('swatch-plus')) {
    event.target.closest('.grid-product__colors').classList.add('expand');
  }
});

// Product Page
if (document.body.classList.contains('template-product')) {
  function showSwatchProductImages(color) {
    const productThumbs = document.querySelectorAll('.product__thumbs img');
    const productTitle = document.querySelector('.product-section').getAttribute('data-product-title');
    
    productThumbs.forEach(img => {
      const productThumb = img.closest('.product__thumb-item');
      productThumb.style.display = 'none';
      
      const altText = img.getAttribute('alt');
      if (altText) {
        if (altText === color || altText === '' || altText === productTitle || altText.includes('.mp4')) {
          productThumb.style.display = 'block';
        }
      }
    });
  }

  const checkForActiveColor = setInterval(function() {
    const checkedColorSwatch = document.querySelector('.variant__input--color-swatch:checked');
    if (checkedColorSwatch) {
      showSwatchProductImages(checkedColorSwatch.value);
      clearInterval(checkForActiveColor);
    }
  }, 100);

  document.body.addEventListener('click', function(event) {
    if (event.target.classList.contains('color-swatch')) {
      showSwatchProductImages(event.target.textContent.trim());
    }
  });
}
/* Careers Page */
if (document.getElementById('careers')) {
  var bookID = "1QtYo_642KBbCTMi38ymkQv5IZjxfwrEv8PR8ShhhHfs",
      sheetID = "128751278",
      qry = encodeURIComponent("SELECT A, B, C WHERE D = TRUE ORDER BY A ASC"),
      url = "https://docs.google.com/spreadsheets/d/" + bookID + "/gviz/tq?tqx=out:csv&tq=" + qry + "&gid=" + sheetID,
      template = document.querySelector('.career-template').innerHTML;

  fetch(url)
    .then(response => response.text())
    .then(data => {
      data = Papa.parse(data, { header: true });
      data = data.data;
      
      if (data.length > 0) {
        data.forEach(item => {
          document.querySelector('.career-template .title').innerHTML = item.Title;
          document.querySelector('.career-template .shortd').innerHTML = item.ShortDescription;

          fetch(item.GoogleDocURL)
            .then(response => response.text())
            .then(nesteddata => {
              // Process the nested HTML data
              nesteddata = nesteddata.split('</style>')[1].split('<div id="footer">')[0];

              // Set the long description and clean up the content
              const longDescription = document.querySelector('.career-template .longd');
              longDescription.innerHTML = nesteddata;
              
              // Remove classes from specific tags
              longDescription.querySelectorAll('p, span, ul, li').forEach(el => el.removeAttribute('class'));
              
              // Style elements with '**' as bold
              longDescription.querySelectorAll('span').forEach(span => {
                if (span.innerHTML.includes('**')) {
                  span.style.fontWeight = 'bold';
                  span.innerHTML = span.innerHTML.replace('**', '');
                }
              });

              // Append the processed content to #careers
              document.getElementById('careers').insertAdjacentHTML('beforeend', document.querySelector('.career-template').innerHTML);

              // Reset the template for the next iteration
              document.querySelector('.career-template').innerHTML = template;
            })
            .catch(error => console.error('Error fetching nested data:', error));
        });
      } else {
        document.querySelector('#careers .no-careers').style.display = 'block';
      }
    })
    .catch(error => console.error('Error fetching spreadsheet data:', error));
}

document.addEventListener("DOMContentLoaded", function() {
  let lazyBackgrounds = document.querySelectorAll('.lazy-background');

  // IntersectionObserver to check if elements are in the viewport
  let observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Load background image
        entry.target.style.backgroundImage = `url(${entry.target.getAttribute('data-src')})`;
        observer.unobserve(entry.target); // Stop observing once loaded
      }
    });
  });

  // Start observing lazy background elements
  lazyBackgrounds.forEach(background => {
    observer.observe(background);
  });
});

function getToday() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();
  if (dd < 10) { dd = '0' + dd; }
  if (mm < 10) { mm = '0' + mm; }
  return yyyy + '-' + mm + '-' + dd;
}

function getPanBy(zoom) {
  if($(window).width() > 1000) {
    return (($(window).width() / zoom)*-1)		
  } else {
    return 50;
  }	
}

function delimit(txt,del) {
  if(txt.length > 0) { return (del + ' ') } else { return '' }
}

var rad = function(x) {
  return x * Math.PI / 180;
};

var getDistance = function(lat1, lon1, lat2, lon2 ) {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(lat2 - lat1);
  var dLong = rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  d = d * 0.0006213712; // converts to miles
  d = d + d*0.43;
  return d; // returns the distance in miles
};

/* Custom Featured Collection — prev/next arrows (sections/custom-featured-collection.liquid)
   The carousel itself is plain CSS scroll-snap (no JS, no library) — this
   just drives the two optional nav buttons with a native scrollBy(), and
   disables/fades each one out once you've reached that end of the track. */
(function () {
  function initSliderNav(wrap) {
    if (wrap.dataset.sliderNavInit) return;
    wrap.dataset.sliderNavInit = 'true';

    var slider = wrap.querySelector('.custom-featured-collection__slider');
    var prevBtn = wrap.querySelector('[data-slider-prev]');
    var nextBtn = wrap.querySelector('[data-slider-next]');
    if (!slider || !prevBtn || !nextBtn) return;

    function cardWidth() {
      var card = slider.querySelector('.grid-product');
      return card ? card.getBoundingClientRect().width : slider.clientWidth;
    }

    prevBtn.addEventListener('click', function () {
      slider.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      slider.scrollBy({ left: cardWidth(), behavior: 'smooth' });
    });

    function updateDisabled() {
      var maxScroll = slider.scrollWidth - slider.clientWidth - 1;
      prevBtn.disabled = slider.scrollLeft <= 0;
      nextBtn.disabled = slider.scrollLeft >= maxScroll;
    }

    slider.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', updateDisabled);
    updateDisabled();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.custom-featured-collection__slider-wrap').forEach(initSliderNav);
  }

  if (document.readyState !== 'loading') {
    initAll();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();

/* Custom Announcement Bar (sections/custom-announcement-bar.liquid) — continuous
   marquee. Adapted from the Impact theme's <marquee-text> pattern: measuring the
   actual rendered content width keeps the scroll SPEED consistent regardless of
   how much text is in it, or how many times it's repeated to guarantee the
   seamless loop (a fixed animation-duration made it race by once the repeat
   count was increased from 2 to 8 to fix the "empty space then jump" bug —
   same total time, four times the distance). */
class CustomAnnouncementMarquee extends HTMLElement {
  constructor() {
    super();
    this._hovering = false;
    this._lastDuration = null;

    // Changing animation-duration on a RUNNING animation shifts its
    // progress percentage and causes a visible jump — skipping recalculation
    // while hovering guarantees a hover/pause can never coincide with a
    // duration change (from any cause: font swap, layout shift, etc.).
    this.addEventListener('mouseenter', () => { this._hovering = true; this._pause(); });
    this.addEventListener('mouseleave', () => { this._hovering = false; this._resume(); });

    if (window.ResizeObserver) {
      this._observer = new ResizeObserver(this._calculateDuration.bind(this));
      this._observer.observe(this);
    }
  }

  // CSS animation-play-state can visibly jump when paused/resumed (a real,
  // long-standing browser quirk with compositor-driven transform animations
  // — see e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=1136627).
  // The Web Animations API's pause()/play() instead freezes and resumes the
  // SAME animation's own internal currentTime directly, which per spec can't
  // jump, so use that instead of an :hover { animation-play-state } rule.
  _pause() {
    var track = this.querySelector('.custom-announcement-bar__track');
    if (!track || !track.getAnimations) return;
    track.getAnimations().forEach(function (anim) {
      anim.pause();
    });
  }

  _resume() {
    var track = this.querySelector('.custom-announcement-bar__track');
    if (!track || !track.getAnimations) return;
    track.getAnimations().forEach(function (anim) {
      anim.play();
    });
  }

  _calculateDuration(entries) {
    if (this._hovering) return;

    var containerWidth = entries[0].contentRect.width;
    if (!containerWidth) return;

    var track = this.querySelector('.custom-announcement-bar__track');
    var oneSet = this.querySelector('.custom-announcement-bar__track-set');
    if (!track || !oneSet) return;

    var oneSetWidth = oneSet.getBoundingClientRect().width;
    if (!oneSetWidth) return;

    var speed = parseFloat(this.dataset.speed) || 15;
    var halfTrackWidth = track.scrollWidth / 2;

    // "Speed" (from the section's Scroll speed setting) is calibrated as
    // seconds to scroll past one un-repeated copy of the content; the actual
    // animation travels half of the many-times-repeated track, so scale the
    // duration by how many copy-widths that half actually spans.
    var duration = speed * (halfTrackWidth / oneSetWidth);

    // Skip no-op/negligible updates too, so measurement noise (sub-pixel
    // rounding, etc.) never nudges a running animation's timeline.
    if (this._lastDuration !== null && Math.abs(duration - this._lastDuration) < 0.05) return;
    this._lastDuration = duration;

    this.style.setProperty('--custom-announcement-marquee-duration', duration.toFixed(2) + 's');
  }
}

if (!window.customElements.get('custom-announcement-marquee')) {
  window.customElements.define('custom-announcement-marquee', CustomAnnouncementMarquee);
}